import _ from 'lodash'
import FormatNumber from './FormatNumber'
import { i18n } from '~src/i18n'
import store from '~store/store'

export const formatNumber = (number, options) => {
  return FormatNumber.format(number || 0, options)
}

export const formatBytes = (size, precision, destinationUnit) => {
  size = size || 0

  if (precision === undefined) {
    precision = 2
  }

  if (!destinationUnit) {
    destinationUnit = ''
  }

  destinationUnit = destinationUnit.toUpperCase()

  const units = {
    B: {
      convert: size => {
        return size
      },
      check: size => {
        return size < 1e3
      }
    },
    KB: {
      convert: size => {
        return size / 1e3
      },
      check: size => {
        return size >= 1e3 && size < 1e6
      }
    },
    MB: {
      convert: size => {
        return size / 1e6
      },
      check: size => {
        return size >= 1e6 && size < 1e9
      }
    },
    GB: {
      convert: size => {
        return size / 1e9
      },
      check: size => {
        return size >= 1e9 && size < 1e12
      }
    },
    TB: {
      convert: size => {
        return size / 1e12
      },
      check: size => {
        return size >= 1e12
      }
    }
  }

  let formattedSize
  let formattedUnits

  if (destinationUnit && units[destinationUnit]) {
    formattedSize = formatNumber(units[destinationUnit].convert(size), { precision })
    formattedUnits = destinationUnit
  } else {
    _.each(units, (unit, unitName) => {
      if (unit.check(size)) {
        formattedSize = formatNumber(unit.convert(size), { precision })
        formattedUnits = unitName
      }
    })
  }

  return formattedSize + ' ' + formattedUnits
}

export default {
  install(Vue) {
    Vue.filter('userName', value => {
      if (!value) return ''
      return store.getters.getUserName(value)
    })

    Vue.filter('capitalize', value => {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    })

    Vue.filter('upper', value => {
      if (!value) return ''
      return value.toString().toUpperCase()
    })

    Vue.filter('lower', value => {
      if (!value) return ''
      return value.toString().toLowerCase()
    })

    // formatNumber
    Vue.filter('formatNumber', formatNumber)
    Vue.prototype.$formatNumber = formatNumber

    // formatUtcDate
    const UTCDate = date => {
      return Vue.moment.utc(date).local()
    }

    Vue.filter('UTCDate', UTCDate)
    Vue.prototype.$UTCDate = UTCDate

    // formatUtcDate

    const formatUTCDate = (date, format) => {
      return !date
        ? ''
        : Vue.moment(date)
            .local()
            .format(format || 'DD/MM/YYYY')
    }

    Vue.filter('formatUTCDate', formatUTCDate)
    Vue.prototype.$formatUTCDate = formatUTCDate

    // formatDate
    const formatDate = (date, format) => {
      return !date ? '' : Vue.moment(date).format(format || 'DD/MM/YYYY')
    }

    Vue.filter('formatDate', formatDate)
    Vue.prototype.$formatDate = formatDate

    // formatMeters

    const formatMeters = (distance, precision, destinationUnit) => {
      distance = distance || 0

      if (precision === undefined) {
        precision = 2
      }

      if (!destinationUnit) {
        destinationUnit = ''
      }

      destinationUnit = destinationUnit.toLowerCase()

      const units = {
        cm: {
          convert: distance => {
            return distance * 100
          },
          check: distance => {
            return distance < 1
          }
        },
        m: {
          convert: distance => {
            return distance
          },
          check: distance => {
            return distance > 1 && distance < 1000
          }
        },
        km: {
          convert: distance => {
            return distance / 1000
          },
          check: distance => {
            return distance >= 1000
          }
        }
      }

      let formattedSize
      let formattedUnits

      if (destinationUnit && units[destinationUnit]) {
        formattedSize = formatNumber(units[destinationUnit].convert(distance), { precision })
        formattedUnits = destinationUnit
      } else {
        _.each(units, (unit, unitName) => {
          if (unit.check(distance)) {
            formattedSize = formatNumber(unit.convert(distance), { precision })
            formattedUnits = unitName
          }
        })
      }

      return formattedSize + ' ' + formattedUnits
    }

    Vue.filter('formatMeters', formatMeters)
    Vue.prototype.$formatMeters = formatMeters

    // formatSqMeters

    const formatSqMeters = (distance, precision, destinationUnit) => {
      distance = distance || 0

      if (precision === undefined) {
        precision = 2
      }

      if (!destinationUnit) {
        destinationUnit = ''
      }

      destinationUnit = destinationUnit.toLowerCase()

      const units = {
        'm²': {
          convert: distance => {
            return distance
          },
          check: distance => {
            return distance < 10000
          }
        },
        ha: {
          convert: distance => {
            return distance / 10000
          },
          check: distance => {
            return distance > 10000 && distance < 10000000
          }
        },
        'km²': {
          convert: distance => {
            return distance / 1000000
          },
          check: distance => {
            return distance >= 10000000
          }
        }
      }

      let formattedSize
      let formattedUnits

      if (destinationUnit && units[destinationUnit]) {
        formattedSize = formatNumber(units[destinationUnit].convert(distance), { precision })
        formattedUnits = destinationUnit
      } else {
        _.each(units, (unit, unitName) => {
          if (unit.check(distance)) {
            formattedSize = formatNumber(unit.convert(distance), { precision })
            formattedUnits = unitName
          }
        })
      }

      return formattedSize + ' ' + formattedUnits
    }

    Vue.filter('formatSqMeters', formatSqMeters)
    Vue.prototype.$formatSqMeters = formatSqMeters

    // formatBytes

    Vue.filter('formatBytes', formatBytes)
    Vue.prototype.$formatBytes = formatBytes

    // formatHours

    const formatHours = (hours, precision, destinationUnit) => {
      hours = hours || 0

      if (precision === undefined) {
        precision = 2
      }

      if (!destinationUnit) {
        destinationUnit = ''
      }

      destinationUnit = destinationUnit.toLowerCase()

      const units = {
        hours: {
          convert: hours => {
            return hours
          },
          check: hours => {
            return hours > 1 && hours < 24
          }
        },
        minutes: {
          convert: hours => {
            return hours * 60
          },
          check: hours => {
            return hours < 1 && hours > 1 / 60
          }
        },
        seconds: {
          convert: hours => {
            return hours * 60 * 60
          },
          check: hours => {
            return hours < 1 / 60
          }
        },
        days: {
          convert: hours => {
            return hours / 24
          },
          check: hours => {
            return hours >= 24
          }
        }
      }

      let formattedSize
      let formattedUnits

      if (destinationUnit && units[destinationUnit]) {
        formattedSize = formatNumber(units[destinationUnit].convert(hours), { precision })
        formattedUnits = destinationUnit
      } else {
        _.each(units, (unit, unitName) => {
          if (unit.check(hours)) {
            formattedSize = formatNumber(unit.convert(hours), { precision })
            formattedUnits = unitName
          }
        })
      }

      return formattedSize + ' ' + i18n.tc(formattedUnits, parseInt(formattedSize), {})
    }

    Vue.filter('formatHours', formatHours)
    Vue.prototype.$formatHours = formatHours
  }
}
